import store from "@/store";
import ApiService from "@/core/services/ApiService";

class UserActivityMonitorService {
  private inactivityTimeout: number;
  private timeoutId: number | undefined;

  constructor(inactivityTimeout = 30) {
    this.inactivityTimeout = inactivityTimeout * 60 * 1000;
    this.timeoutId = undefined;
    this.resetTimer = this.resetTimer.bind(this);
    this.handleUserActivity = this.handleUserActivity.bind(this);
    this.logout = this.logout.bind(this); // Bind the context for the logout method
  }

  public startMonitoring(): void {
    this.resetTimer(); // Start the timer when monitoring begins
    window.addEventListener("mousemove", this.handleUserActivity);
    window.addEventListener("keydown", this.handleUserActivity);
    window.addEventListener("touchstart", this.handleUserActivity);
  }

  public stopMonitoring(): void {
    // Clean up the event listeners and timer
    window.removeEventListener("mousemove", this.handleUserActivity);
    window.removeEventListener("keydown", this.handleUserActivity);
    window.removeEventListener("touchstart", this.handleUserActivity);
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  private resetTimer(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.timeoutId = window.setTimeout(this.logout, this.inactivityTimeout);
  }

  private handleUserActivity(): void {
    this.resetTimer();
  }

  private async logout(): Promise<void> {
    this.stopMonitoring();
    try {
      const res = await ApiService.get(`/api/logout`);
      if (res.data.status === "success") {
        await store.dispatch("logout");
        window.location.href = "/sign-in";
      }
    } catch (error) {
      console.error("Error occurred during logout:", error);
    } finally {
      console.log("Logged out");
    }
  }
}

export default UserActivityMonitorService;
